<template>
  <div class="theme-box">
    <div class="theme-top slidetop" data-scroll data-scroll-call="animateMove">
      <strong>{{timers | timeFormat('mm/dd')}}</strong>
      <strong>议程主题</strong>
      <strong>演讲嘉宾</strong>
    </div>
    <ul class="theme-list">
      <li v-for="(item, index) in agendaDatas" :key="item.id" class="slidetop" data-scroll data-scroll-call="animateMove">
        <time>{{item.from_time}}-{{item.to_time}}</time>
        <div class="theme-info" @mouseenter.stop="slideDown(index)" @mouseleave.stop="slideUp(index)">
          <strong v-html="item.title"></strong>
          <div class="theme-desc">
            <p ref="start" class="detail" v-html="item.description"></p>
            <p ref="end" class="dshow" v-html="item.description"></p>
          </div>
        </div>
        <div class="theme-water">
          <div class="water-item" v-for="(item1) in item.guests" :key="item1.id" @click="guestview(item1)">
            <router-link to="/2022/guest">
              <figure><img :src="item1.smallface" alt=""/></figure>
              <p v-html="item1.user"></p>
            </router-link>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      setHeight: 0,
      setHeightList: [],
      offIn: 56,
      timers: 0
    }
  },
  props: {
    agendaDatas: Array
  },
  created () {
    this.getAgendaInfo()
  },
  methods: {
    guestview (item) {
      this.$parent.$parent.setPopShow(item)
    },
    async getAgendaInfo () {
      const id = this.$route.params.zone_id
      const { data: res } = await this.$http.get(`zones/${id}`)
      this.timers = res.data.the_date
      console.log(this.timers)
    },
    slideDown (index) {
      this.setHeight = this.$refs.start[index].offsetHeight
      this.$refs.start[index].style.height = this.$refs.end[index].offsetHeight + 'px'
    },
    slideUp (index) {
      this.$refs.start[index].style.height = this.offIn + 'px'
    }
  }
}
</script>

<style lang="less" scoped>
  @import url("@/assets/css/agenda/index.less");
</style>